import {Component,OnInit,Input,ViewChild,ViewEncapsulation,Output,EventEmitter,OnDestroy} from '@angular/core';
import { Subscription } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import {DialogService} from '@rbaip/ui-component';
import { assetMoveDestinationTypeName, MOVE_ASSET_INTO_AUCTION_EVENT, MOVE_ASSET_BACK_TO_OPPORTUNITY, MOVE_ASSET_INTO_HOLDING_PEN,
  MOVE_ASSET_INTO_OTHER_OPPORTUNITY, MOVE_ASSET_INTO_OTHER_CONTRACT, MOVE_ASSET_BACK_TO_WIP, RETURN_TO_PREVIOUS_SALE, AssetSaleInfo,
  Asset, RBA_LIVE, RESELL_ASSET, ASSET_STATUS_MISSING_INFO, ASSET_STATUS_INFO_COMPLETE, ASSET_STATUS_CONTRACT_READY, ASSET_STATUS_SOLD,
  ASSET_STATUS_COLLAPSED_TO_INVENTORY, ASSET_STATUS_COLLAPSED_TO_SELLER, ASSET_STATUS_LOT_PULLED, ASSET_STATUS_SYNCED_UNSIGNED,
  ASSET_STATUS_SYNCED_SIGNED, ASSET_STATUS_SELLING, ASSET_STATUS_NOT_SOLD, ASSET_STATUS_CONTRACTED, ASSET_STATUS_BUYER_ABANDONED, AuditAssetMove, EquipScheduleA,
  assetMessage, assetMoveErrorCodes, INVENTORY_CONTROL } from '../../../shared/domain/item';
import {permissionType, PermissionUtils} from '../../../shared/permission';
import { FormControl} from '@angular/forms';
import {debounceTime, distinctUntilChanged} from 'rxjs/operators';
import { MatOptionSelectionChange } from '@angular/material/core';
import { MatStepper } from '@angular/material/stepper';
import {
  ASSET_PACKAGE_STATUS_IN_PRICING, ASSET_PACKAGE_STATUS_RESENT_FOR_PRICING,
  ASSET_PACKAGE_STATUS_SENT_FOR_PRICING
} from '../../../shared/domain/asset-package';
import {LookupContractOpportunityAdvancedComponent} from '../../lookup-contract-opportunity-advanced/lookup-contract-opportunity-advanced.component';
import {UserSessionService} from '@rbaip/ui-component';
import {Opportunity, OpportunityContract, OPPORTUNITY_STAGE, OpportunityStage,
  OpportunityContractLookupType
} from '../../../shared/domain/opportunity';
import {ItemSummaryOpportunityService} from '../../../shared/opportunity/item-summary-opportunity.service';
import {ItemSummaryAssetControlGroupService} from '../../../shared/asset-package/item-summary-asset-control-group.service';
import {ItemSummaryAssetsService} from '../../../shared/asset/item-summary-assets.service';
import {SaleOwner, SiteHoldingPen} from '../../../shared/domain/auction-event';
import {ItemSummarySiteAuctionEventServiceImpl} from '../../../shared/auction-event/item-summary-site-auction-event-impl.service';
import {ItemSummarySiteAuctionEventService} from '../../../shared/auction-event/item-summary-site-auction-event.service';
import {ItemSummaryScheduleNumberService} from '../../../shared/asset/item-summary-schedule-number.service';
import {ItemSummaryScheduleNumberServiceImpl} from '../../../shared/asset/item-summary-schedule-number-impl.service';
import {ContractStatus, ContractType} from '../../../shared/domain/contract';
import {CreateAddendumComponent} from "../create-addendum/create-addendum.component";

@Component({
  selector: 'lib-item-summary-asset-move-destination',
  templateUrl: './asset-move-destination.component.html',
  styleUrls: ['./asset-move-destination.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [
    {provide: ItemSummarySiteAuctionEventService, useClass: ItemSummarySiteAuctionEventServiceImpl},
    {provide: ItemSummaryScheduleNumberService, useClass: ItemSummaryScheduleNumberServiceImpl}
  ]
})
export class AssetMoveDestinationComponent implements OnInit, OnDestroy {

  @Input() auditAssetMove: AuditAssetMove;
  @Input() stepper: MatStepper;
  @Input() assets: Asset[];
  @Input('displayResellOption') displayResellOption: boolean;
  @Input() isEventEndedMoreThan30DaysAgo: boolean;
  @Input() isEventEndedMoreThan120DaysAgo: boolean;
  @Input() canMoveSoldRBAsset: boolean;
  @Input() canMoveSoldIPAsset: boolean;
  @Output() isAuctionEventContractSelected = new EventEmitter();

  @ViewChild('icForm') icForm: HTMLFormElement;

  public assetMoveDestinationTypeName = assetMoveDestinationTypeName;
  public MOVE_ASSET_INTO_AUCTION_EVENT = MOVE_ASSET_INTO_AUCTION_EVENT;
  public MOVE_ASSET_BACK_TO_OPPORTUNITY = MOVE_ASSET_BACK_TO_OPPORTUNITY;
  public MOVE_ASSET_INTO_HOLDING_PEN = MOVE_ASSET_INTO_HOLDING_PEN;
  public MOVE_ASSET_INTO_OTHER_OPPORTUNITY = MOVE_ASSET_INTO_OTHER_OPPORTUNITY;
  public MOVE_ASSET_INTO_OTHER_CONTRACT = MOVE_ASSET_INTO_OTHER_CONTRACT;
  public MOVE_ASSET_BACK_TO_WIP = MOVE_ASSET_BACK_TO_WIP;
  public RETURN_TO_PREVIOUS_SALE = RETURN_TO_PREVIOUS_SALE;
  public RESELL_ASSET = RESELL_ASSET;
  public opportunitySearchParam: FormControl = new FormControl();
  public filteredOpportunities: OpportunityContract[] = [];
  public selectedOpportunity: OpportunityContract;
  public selectedContract: OpportunityContract;

  public disableAuctionEvent = false;
  public disableBackToWip = false;
  public disableBackToOpportunity = false;
  public disableHoldingPen = false;
  public disableOtherOpportunity = false;
  public disableOtherContract = false;
  public disableReturnToPreviousSale = false;
  public disableResellAsset = false;
  public selectedValue: string;
  public loadingOpportunities = false;
  public noResultFound = false;
  public ownerCode: string;
  public scheduleA: number;
  public isOwnerCodeAvailable = true;
  public isScheduleAAvailable = true;
  public isOwnerCodeDefinedAlready = false;
  public hasIpAssets = false;
  public isUserSelectingOpportunity = false;

  private hasCanMoveAssetPermission = false;

  public currentOpportunity: Opportunity;
  private siteHoldingPen: SiteHoldingPen;
  private selectedSaleOwner: SaleOwner;
  private schedules: EquipScheduleA[];
  private nextScheduleANumber = 1;
  private readonly ONLINE = 'Online';
  private isOpportunityOrContractCurrencyDifferent = false;
  private typeOfRiskError: string = null;

  private opportunitySearchParamControlSubscription: Subscription;
  private opportunitySubscription: Subscription;
  private siteHoldingPenSubscription: Subscription;
  private scheduleASubscription: Subscription;
  private operationalEntitySubscription: Subscription;
  private assetPackageSubscription: Subscription;
  currentUserChangedSubscription: Subscription;
  public isTm : boolean;
  public isRm :  boolean;
  isPackageContributor: boolean;
  workInProgressTab: boolean;
  contractReadyTab: boolean;
  presaleAndSellingTab: boolean;
  soldTab: boolean;
  notSoldTab: boolean;
  previousAuctionEventName: string;

  constructor(private userSessionService: UserSessionService,
              private siteAuctionEventService: ItemSummarySiteAuctionEventService,
              private opportunityService: ItemSummaryOpportunityService,
              private scheduleNumberService: ItemSummaryScheduleNumberService,
              private assetControlGroupService: ItemSummaryAssetControlGroupService,
              private assetsService: ItemSummaryAssetsService,
              private dialog: MatDialog,
              private dialogService: DialogService) {
    this.subscribeOpportunitySearchChange();
    this.subscribeSiteHoldingPen();
    this.subscribeSiteHoldingPenSchedules();
    this.subscribeUserChanged();
    if (this.userSessionService.getCurrentUser()){
      this.isCurrentUserIsPackageTeamMember(this.userSessionService.getCurrentUser().userId);
    }
  }

  private isCurrentUserIsPackageTeamMember(userId: number){
    if(this.assets && this.assets.length > 0){
      this.assetControlGroupService.isPackageTeamMember(this.assets[0].assetControlGroupId, userId).subscribe( userRoleType => {
        if (userRoleType) {
          this.isTm = userRoleType.tm;
          this.isRm = userRoleType.rm;
        }
        this.loadPagePermission();
      })
    }
  }

  private loadPagePermission() {
    this.hasCanMoveAssetPermission = PermissionUtils.hasPermission(this.userSessionService, permissionType.canMoveAsset);
    this.isPackageContributor = PermissionUtils.hasPermission(this.userSessionService, permissionType.canCreateEditAssetPackage);
    this.canMoveSoldRBAsset = PermissionUtils.hasPermission(this.userSessionService, permissionType.canMoveSoldRBAsset);
    this.canMoveSoldIPAsset = PermissionUtils.hasPermission(this.userSessionService, permissionType.canMoveSoldIPAsset);
  }

  private subscribeUserChanged(){
    this.currentUserChangedSubscription = this.userSessionService.userChanged
      .subscribe(( siteUser ) => {
        if (siteUser) {
          this.isCurrentUserIsPackageTeamMember(siteUser.userId);
        }
      });
  }

  ngOnInit() {
    this.subscribeAssetPackage();
    this.configureDestinationTypes();
  }

  ngOnDestroy() {
    if (this.opportunitySearchParamControlSubscription) {
      this.opportunitySearchParamControlSubscription.unsubscribe();
    }
    if (this.opportunitySubscription) {
      this.opportunitySubscription.unsubscribe();
    }
    if (this.siteHoldingPenSubscription) {
      this.siteHoldingPenSubscription.unsubscribe();
    }
    if (this.scheduleASubscription) {
      this.scheduleASubscription.unsubscribe();
    }
    if (this.operationalEntitySubscription) {
      this.operationalEntitySubscription.unsubscribe();
    }
    if (this.assetPackageSubscription) {
      this.assetPackageSubscription.unsubscribe();
    }
    if(this.currentUserChangedSubscription){
      this.currentUserChangedSubscription.unsubscribe();
    }
  }

  public onDestinationTypeChange(destinationType: string): void {
    this.auditAssetMove.destinationType = destinationType;
    this.selectedOpportunity = null;
    this.selectedContract = null;
    this.isOpportunityOrContractCurrencyDifferent = false;
    this.auditAssetMove.selectedOpportunity = null;
    this.auditAssetMove.selectedContract = null;
    this.validate();
  }

  public getOpportunityName(opportunity: OpportunityContract): string {
    if (opportunity) {
      return opportunity.legalName ? (opportunity.legalName + ' - ' + opportunity.opportunityName) : opportunity.opportunityName;
    } else {
      return '';
    }
  }

  public onOpportunitySelection(event: MatOptionSelectionChange) {
    this.selectedOpportunity = null;
    this.isUserSelectingOpportunity = true;
  }

  public selectContract(selectedContract): void {
    this.selectedContract = selectedContract;
    this.isAuctionEventContractSelected.emit(ContractType.isAuctionEventContract(this.selectedContract.salesHubContractType));
    this.validateTypeOfRiskError();
  }

  public isNextButtonEnabled(): boolean {
    if (!this.auditAssetMove.destinationType) {
      return false;
    } else if (this.auditAssetMove.destinationType == MOVE_ASSET_INTO_OTHER_OPPORTUNITY && !this.selectedOpportunity) {
      return false;
    } else if (this.auditAssetMove.destinationType == MOVE_ASSET_INTO_OTHER_CONTRACT && !this.selectedContract) {
      return false;
    } else if (this.auditAssetMove.destinationType == MOVE_ASSET_INTO_HOLDING_PEN && !this.isHoldingPenInfoValid()) {
      return false;
    } else if(this.auditAssetMove.destinationType == MOVE_ASSET_INTO_AUCTION_EVENT && this.isExhibitAOrInventoryContract() &&!this.selectedContract){
      return false;
    } else {
      return true;
    }
  }

  public continueToNextStep(): void {
    let errorMessage = null;
    const warningMessage = null;
    this.auditAssetMove.selectedContract = null;
    this.auditAssetMove.selectedOpportunity = null;
    if (this.auditAssetMove.destinationType == MOVE_ASSET_INTO_OTHER_OPPORTUNITY && !!this.selectedOpportunity.ipContractId) {
      this.auditAssetMove.destinationType = MOVE_ASSET_INTO_OTHER_CONTRACT;
      this.selectedContract = this.selectedOpportunity;
    }

    let isSelectedOpportunityInPricing : boolean;
    if (this.selectedOpportunity && this.selectedOpportunity.acgStatusId) {
      isSelectedOpportunityInPricing = this.isPackageInPricing( this.selectedOpportunity.acgStatusId.toString());
    }

    let isSelectedContractInPricing : boolean;
    if (this.selectedContract && this.selectedContract.acgStatusId) {
      isSelectedContractInPricing = this.isPackageInPricing( this.selectedContract.acgStatusId.toString());
    }

    if ( this.auditAssetMove.destinationType === MOVE_ASSET_INTO_OTHER_OPPORTUNITY ) {
      if ( isSelectedOpportunityInPricing ) {
        errorMessage = 'Assets cannot be moved to the selected opportunity as it is currently in pricing. ';
      } else if ( this.selectedOpportunity.opportunityStage == OPPORTUNITY_STAGE.closedLost ) {
        errorMessage = 'Assets cannot be moved to the selected opportunity as it is closed. ';
      }
      this.auditAssetMove.selectedOpportunity = this.selectedOpportunity;
      this.auditAssetMove.newOpportunityId = this.selectedOpportunity.opportunityId;
    } else if ( this.auditAssetMove.destinationType === MOVE_ASSET_INTO_OTHER_CONTRACT ) {
      if ( isSelectedContractInPricing ) {
        errorMessage = 'Assets cannot be moved to the selected contract as it is currently in pricing. ';
      } else if ( ContractStatus.isFinalized(this.selectedContract.shContractStatus) ) {
        errorMessage = assetMessage.shTargetContractFinalizedMoveError.message;
      } else if ( !this.selectedContract.ipContractId ) {
        errorMessage = assetMessage.contractMoveOppWithNoContractError.message;
      } else if (this.shouldValidateOperationalEntity() && ContractType.isAuctionEventContract(this.selectedContract.salesHubContractType) && this.isDifferentSourceTargetEventContract()) {
        errorMessage = assetMessage.contractMoveOppWithDifferentEventError.message;
      }
      this.auditAssetMove.selectedContract = this.selectedContract;
      this.auditAssetMove.newContractId = this.selectedContract.ipContractId;
      this.auditAssetMove.newOpportunityId = this.selectedContract.opportunityId;
      this.auditAssetMove.contractMoveType = MOVE_ASSET_INTO_OTHER_CONTRACT;
    } else if (this.auditAssetMove.destinationType === MOVE_ASSET_INTO_HOLDING_PEN) {
      if (this.assets[0].saleType === RBA_LIVE) {
        this.assets.forEach(asset => {
          if (this.ownerCode) {
            asset.ownerCode = this.ownerCode;
          }
          if (this.scheduleA) {
            asset.scheduleA = this.scheduleA++;
          }
        });
      }
    } else if (this.auditAssetMove.destinationType === MOVE_ASSET_INTO_AUCTION_EVENT && this.isExhibitAOrInventoryContract()) {
      if ( isSelectedContractInPricing ) {
        errorMessage = 'Assets cannot be moved to the selected contract as it is currently in pricing. ';
      } else if ( ContractStatus.isFinalized( this.selectedContract.shContractStatus ) ) {
        errorMessage = assetMessage.shTargetContractFinalizedMoveError.message;
      } else if ( !this.selectedContract.ipContractId ) {
        errorMessage = assetMessage.contractMoveOppWithNoContractError.message;
      }
      this.auditAssetMove.destinationType = this.MOVE_ASSET_INTO_OTHER_CONTRACT;
      this.auditAssetMove.selectedContract = this.selectedContract;
      this.auditAssetMove.newContractId = this.selectedContract.ipContractId;
      this.auditAssetMove.newOpportunityId = this.selectedContract.opportunityId;
      this.auditAssetMove.contractMoveType = MOVE_ASSET_INTO_AUCTION_EVENT;
    }

    if (errorMessage) {
      this.dialogService.showMessageDialog({message: errorMessage});
    } else if (warningMessage) {
      this.dialogService.showMessageDialog({message: warningMessage}).afterClosed().subscribe(response => {
        this.stepper.next();
      });
    } else {
      if (this.shouldValidateOperationalEntity() && !!this.selectedContract.opportunityId) {
        this.validateOperationalEntity(this.selectedContract.opportunityId);
      } else {
        if (this.isOpportunityOrContractCurrencyDifferent) {
          this.dialogService.showMessageDialog(assetMessage.opportunityOrContractDifferentCurrencyWarning)
            .afterClosed().subscribe(response => {
            if (response) {
              this.assets.forEach(asset => {
                AssetSaleInfo.resetSaleInfoForAsset(asset);
                asset.rnrBudget = null;
                asset.haulingBudget = null;
                asset.listFeeAmt = null;
              });
              if (this.typeOfRiskError) {
                this.validateRiskContracts();
              } else {
                this.stepper.next();
              }
            }
          });
        } else {
          if (this.typeOfRiskError) {
            this.validateRiskContracts();
          } else {
            this.stepper.next();
          }
        }
      }
    }
  }

  public getOpportunityStageColor(opportunityStage: string): string {
    return OpportunityStage.getOpportunityStageColor(opportunityStage);
  }

  public onOwnerCodeChange(): void {
    this.isOwnerCodeAvailable = true;
    this.isScheduleAAvailable = true;
    if (this.ownerCode) {
      this.ownerCode = this.ownerCode.toUpperCase();
      if (this.selectedSaleOwner && this.selectedSaleOwner.ownerCode && this.selectedSaleOwner.ownerCode === this.ownerCode) {
        this.scheduleA = this.nextScheduleANumber;
      } else {
        const existingSaleOwners = this.siteHoldingPen.saleOwners.filter(saleOwner => {
          return saleOwner.ownerCode === this.ownerCode;
        });
        if (existingSaleOwners && existingSaleOwners.length > 0) {
          this.isOwnerCodeAvailable = false;
        } else {
          this.scheduleA = 1;
        }
      }
    }
  }

  public onScheduleAChange(): void {
    if ((this.scheduleA && this.scheduleA < this.nextScheduleANumber) || this.scheduleA === 0) {
      this.isScheduleAAvailable = false;
    } else {
      this.isScheduleAAvailable = true;
    }
  }

  public displayAdvancedSearchDialog(): void {
    this.filteredOpportunities = [];
    this.dialog.open(LookupContractOpportunityAdvancedComponent, {
      width: '100%',
      height: '100%',
      data: {lookupType: OpportunityContractLookupType.Opportunity,
             currentOpportunity: this.currentOpportunity},
      disableClose: true
    }).afterClosed().subscribe(opportunity => {
      if (opportunity) {
        this.noResultFound = false;
        this.isUserSelectingOpportunity = true;
        this.filteredOpportunities.push(opportunity);
        this.opportunitySearchParam.setValue(opportunity);
      }
    });
  }

  private configureDestinationTypes(): void {
    this.enableAllTypes();
    const now = new Date();
    if (this.assets && this.assets.length > 0){
      let assetsWithDifferentEvent;
      const notLotPulledAssets = this.assets.filter(asset => asset.assetStatusId !== ASSET_STATUS_LOT_PULLED);
      const lotPulledAssets = this.assets.filter(asset => asset.assetStatusId === ASSET_STATUS_LOT_PULLED);
      if (lotPulledAssets && lotPulledAssets.length > 0){
        const auctionEventId = lotPulledAssets[0].pulledFromAuctionEventId;
        assetsWithDifferentEvent = lotPulledAssets.filter(asset => asset.pulledFromAuctionEventId != auctionEventId);
      }
      // if multiple assets  with different status selected then do not show return to previous event button
      if ((notLotPulledAssets && notLotPulledAssets.length  > 0 ) || (assetsWithDifferentEvent && assetsWithDifferentEvent.length > 0)){
        this.disableReturnToPreviousSale = true;
      }
      // allow previous sale action only if previous sale is in future
      if (lotPulledAssets && lotPulledAssets.length > 0 && assetsWithDifferentEvent && assetsWithDifferentEvent.length == 0){
        const auctionStartDate= lotPulledAssets[0].pulledFromAuctionStartDate;
        this.previousAuctionEventName = lotPulledAssets[0].pulledFromAuctionEventName;
        this.disableReturnToPreviousSale = auctionStartDate < now ;
      }
    }

    this.assets.forEach( asset => {
      if (asset.saleType === RBA_LIVE && !asset.isCheckedIn) {
        this.disableHoldingPen = true;
      }
      if ((asset.saleType === RBA_LIVE || asset.saleType === INVENTORY_CONTROL) && asset.isCheckedIn) {
        this.disableBackToOpportunity = true;
        this.disableOtherOpportunity = true;
      }
      this.hasIpAssets = asset.saleType !== RBA_LIVE ? true : this.hasIpAssets;
      const assetStatus = asset.assetStatusId;
      this.checkPermission(asset.assetStatusId);
      switch (assetStatus) {
        case ASSET_STATUS_MISSING_INFO:
          this.disableBackToWip = true;
          this.disableBackToOpportunity = true;
          this.disableHoldingPen = true;
          this.workInProgressTab=true;
          break;
        case ASSET_STATUS_INFO_COMPLETE:
          this.disableBackToWip = true;
          this.disableBackToOpportunity = true;
          this.disableHoldingPen = true;
          this.workInProgressTab=true;
          break;
        case ASSET_STATUS_CONTRACT_READY:
          this.disableBackToOpportunity = true;
          this.disableHoldingPen = true;
          this.contractReadyTab = true;
          break;
        case ASSET_STATUS_CONTRACTED:
          this.disableBackToOpportunity = true;
          this.disableHoldingPen = true;
          this.contractReadyTab = true;
          break;
        case ASSET_STATUS_SYNCED_UNSIGNED:
          this.disableBackToWip = true;
          this.presaleAndSellingTab = true;
          break;
        case ASSET_STATUS_SYNCED_SIGNED:
          this.disableBackToWip = true;
          this.presaleAndSellingTab = true;
          break;
        case ASSET_STATUS_SELLING:
          this.disableBackToWip = true;
          this.presaleAndSellingTab = true;
          break;
        case ASSET_STATUS_SOLD:
          this.disableBackToWip = true;
          this.disableBackToOpportunity = true;
          this.disableHoldingPen = true;
          this.disableOtherOpportunity = true;
          this.disableAuctionEvent = true;
          this.soldTab = true;
          break;
        case ASSET_STATUS_COLLAPSED_TO_INVENTORY:
          this.disableBackToWip = true;
          this.disableBackToOpportunity = true;
          this.disableHoldingPen = true;
          this.disableAuctionEvent = true;
          this.disableOtherOpportunity = true;
          this.notSoldTab = true;
          break;
        case ASSET_STATUS_COLLAPSED_TO_SELLER:
          this.disableBackToWip = true;
          this.disableBackToOpportunity = true;
          this.disableOtherOpportunity = true;
          this.notSoldTab = true;
          break;
        case ASSET_STATUS_LOT_PULLED:
          this.disableBackToWip = true;
          this.disableBackToOpportunity = true;
          this.disableHoldingPen = true;
          this.notSoldTab = true;
          break;
        case ASSET_STATUS_NOT_SOLD:
          this.disableBackToWip = true;
          this.disableBackToOpportunity = true;
          this.notSoldTab = true;
          break;
        case ASSET_STATUS_BUYER_ABANDONED:
          this.disableBackToWip = true;
          this.disableBackToOpportunity = true;
          this.disableHoldingPen = true;
          this.disableOtherOpportunity = true;
          this.disableAuctionEvent = true;
          this.disableOtherContract = true;
          this.soldTab = true;
          break;
        default:
          this.disableAllTypes();
          break;
      }
    });
  }

  private checkPermission(assetStatus: number): void {
     if (this.isTm) {
       if ( assetStatus != ASSET_STATUS_MISSING_INFO && assetStatus != ASSET_STATUS_INFO_COMPLETE &&
         assetStatus != ASSET_STATUS_CONTRACT_READY && assetStatus != ASSET_STATUS_LOT_PULLED) {
         this.disableAllTypes();
       }
     }
  }

  private disableAllTypes(): void {
    this.disableBackToWip = true;
    this.disableAuctionEvent = true;
    this.disableHoldingPen = true;
    this.disableBackToOpportunity = true;
    this.disableOtherOpportunity = true;
    this.disableOtherContract = true;
    this.disableReturnToPreviousSale= true;
  }

  private enableAllTypes(): void {
    this.disableBackToWip = false;
    this.disableAuctionEvent = false;
    this.disableHoldingPen = false;
    this.disableBackToOpportunity = false;
    this.disableOtherOpportunity = false;
    this.disableOtherContract = false;
    this.disableReturnToPreviousSale = false;
  }

  private subscribeOpportunitySearchChange(): void {
    this.opportunitySearchParam.valueChanges
      .pipe(debounceTime(1000),
            distinctUntilChanged())
      .subscribe(searchParameter => {
        this.selectedOpportunity = null;
        if (!this.isUserSelectingOpportunity) {
          this.loadOpportunities(searchParameter);
        } else {
          this.selectedOpportunity = this.filteredOpportunities.length > 0 ? this.opportunitySearchParam.value : null;
          this.isUserSelectingOpportunity = false;
          this.isAuctionEventContractSelected.emit(ContractType.isAuctionEventContract(this.selectedOpportunity.salesHubContractType));
          this.validateOpportunityCurrency();
        }
      });
  }

  private loadOpportunities(searchParameter: string): void {
    this.loadingOpportunities = true;
    this.noResultFound = false;
    this.filteredOpportunities = [];
    this.opportunitySearchParamControlSubscription = this.opportunityService.loadOpportunitiesForAutoComplete(searchParameter).subscribe(
      data => {
        this.filteredOpportunities = data as OpportunityContract[];
        //No need to show source opportunity as we don't need to move to same opportunity
        this.filteredOpportunities = this.filteredOpportunities.filter( opportunity => opportunity.opportunityId !== this.currentOpportunity.ipOpportunityId);
        this.loadingOpportunities = false;
        if ( !this.filteredOpportunities || this.filteredOpportunities.length == 0 ) {
          this.noResultFound = true;
        }
      });
  }

  private validateOpportunityCurrency(): void {
    this.isOpportunityOrContractCurrencyDifferent = false;
    if (this.selectedOpportunity.currencyCode != this.currentOpportunity?.currencyCode) {
      this.isOpportunityOrContractCurrencyDifferent = true;
    }
  }

  private validateTypeOfRiskError(): void {
    this.typeOfRiskError = null
    if (ContractType.isRiskContract(this.selectedContract.salesHubContractType) || this.isAtRiskContract()) {
      this.typeOfRiskError = assetMessage.atRiskTargetContractWarning.message;
      if (this.isAtRiskContract())
        this.typeOfRiskError = assetMessage.atRiskContractWarning.message;
      if (ContractType.isRiskContract( this.selectedContract.salesHubContractType) && this.isAtRiskContract())
        this.typeOfRiskError = assetMessage.atRiskToAnotherRiskWarning.message;
    }
    this.validateTargetContractCurrency();
  }

  private validateRiskContracts(): void {
    if (this.selectedContract) {
      this.dialog.open(CreateAddendumComponent, {
        panelClass: 'mat-panel--default',
        data: {
          opportunity: this.currentOpportunity,
          errorMessage: this.typeOfRiskError,
          currentStepper: this.stepper
        }
      }).afterClosed().subscribe(response => {
      });
    }
  }

  private isAtRiskContract(): boolean {
    return this.currentOpportunity && ContractType.isRiskContract(this.currentOpportunity.contractRecordType);
  }

  private isAtStraightContract(): boolean {
    return this.currentOpportunity && ContractType.isStraightContract(this.currentOpportunity.contractRecordType);
  }

  public isExhibitAOrInventoryContract(){
    return this.currentOpportunity && ContractType.isAuctionEventContract(this.currentOpportunity.contractRecordType);
  }

  private validateTargetContractCurrency(): void {
    this.isOpportunityOrContractCurrencyDifferent = false;
    this.selectedContract.currencyCode = this.selectedContract.currencyCode == null ? this.currentOpportunity?.currencyCode : this.selectedContract.currencyCode;
    if (this.selectedContract.currencyCode != this.currentOpportunity?.currencyCode) {
      this.isOpportunityOrContractCurrencyDifferent = true;
    }
  }

  private isPackageInPricing(statusIdStr: string): boolean {
    const statusId = Number(statusIdStr);
    return statusId === ASSET_PACKAGE_STATUS_SENT_FOR_PRICING || statusId === ASSET_PACKAGE_STATUS_IN_PRICING || statusId ===  ASSET_PACKAGE_STATUS_RESENT_FOR_PRICING;
  }

  private getOpportunityDetails(opportunityId: number): void {
    if (opportunityId) {
      this.opportunitySubscription = this.opportunityService.getOpportunityDetails(opportunityId).subscribe(
        opportunity => {
          this.currentOpportunity = opportunity;
          this.auditAssetMove.currentOpportunity = opportunity;
          if (this.assets[0].siteId && opportunity.sellerContractId) {
            if (this.assets[0].saleType === RBA_LIVE) {
              this.siteAuctionEventService.getSiteHoldingPen(this.assets[0].siteId);
              this.scheduleNumberService.getSchedulesForSiteHoldingPenAndContract(this.assets[0].siteId, opportunity.sellerContractId);
            }
          }
          this.opportunityService.selectedOpportunityChanged.next(opportunity);
          this.dialogService.hideProgress();
        });
    } else {
      this.dialogService.hideProgress();
    }
  }

  private subscribeSiteHoldingPen(): void {
    this.siteHoldingPenSubscription = this.siteAuctionEventService.siteHoldingPenCallback.subscribe(
      (response) => {
        this.siteHoldingPen = response;
        if (this.siteHoldingPen && this.siteHoldingPen.saleOwners) {
          const selectedSaleOwners = this.siteHoldingPen.saleOwners.filter(saleOwner => {
            return saleOwner.contractId === this.currentOpportunity?.sellerContractId;
          });
          if (selectedSaleOwners && selectedSaleOwners.length > 0) {
            this.selectedSaleOwner = selectedSaleOwners[0];
            this.ownerCode = this.selectedSaleOwner.ownerCode;
            this.isOwnerCodeDefinedAlready = true;
          }
        }
      });
  }

  private subscribeSiteHoldingPenSchedules(): void {
    this.scheduleASubscription = this.scheduleNumberService.siteHoldingPenSchedulesCallback.subscribe(
      (response) => {
        this.schedules = response;
        if (this.schedules && this.schedules.length > 0) {
          const lastUsedScheduleNumber = this.schedules.reduce((max, schedule) => schedule.scheduleANumber > max ? schedule.scheduleANumber : max, this.schedules[0].scheduleANumber);
          this.nextScheduleANumber = lastUsedScheduleNumber + 1;
        } else {
          this.nextScheduleANumber = 1;
        }
        this.scheduleA = this.nextScheduleANumber;
      });
  }

  private validate(): void {
    let errorMessage;
    let warningMessage;
    if (this.auditAssetMove.destinationType === MOVE_ASSET_INTO_HOLDING_PEN) {
      let saleChannelToCompare;
      let assetSaleChannel;
      let siteToCompare;
      this.assets.forEach(asset => {
        assetSaleChannel = (asset.saleType === RBA_LIVE ? RBA_LIVE : this.ONLINE);
        if (!saleChannelToCompare) {
          saleChannelToCompare = assetSaleChannel;
        } else if (saleChannelToCompare !== assetSaleChannel) {
          errorMessage = assetMessage.crossChannelOrRbSiteError;
        }
        if (!errorMessage && assetSaleChannel === RBA_LIVE) {
          if (!siteToCompare) {
            siteToCompare = asset.siteId;
          } else if ( siteToCompare !== asset.siteId ) {
            errorMessage = assetMessage.crossChannelOrRbSiteError;
          }
        }
      });
    } else if (this.auditAssetMove.destinationType === MOVE_ASSET_INTO_OTHER_OPPORTUNITY || this.auditAssetMove.destinationType === MOVE_ASSET_INTO_OTHER_CONTRACT) {
      if (this.currentOpportunity && ContractStatus.isFinalized(this.currentOpportunity.contractState)) {
        errorMessage = assetMessage.shContractFinalizedMoveError;
      }

      if (this.auditAssetMove.destinationType === MOVE_ASSET_INTO_OTHER_CONTRACT) {
        const hasSoldAssets = this.assets.some(asset => asset.assetStatusId === ASSET_STATUS_SOLD);
        const hasRBSoldAssets = this.assets.some(asset => asset.assetStatusId === ASSET_STATUS_SOLD && asset.saleType === RBA_LIVE);
        const hasIPSoldAssets = this.assets.some(asset => asset.assetStatusId === ASSET_STATUS_SOLD && asset.saleType !== RBA_LIVE);
        const hasCollapsedToInventoryAssets = this.assets.some(asset => asset.assetStatusId === ASSET_STATUS_COLLAPSED_TO_INVENTORY && asset.saleType === RBA_LIVE);
        const hasCollapsedToSellerAssets = this.assets.some(asset => asset.assetStatusId === ASSET_STATUS_COLLAPSED_TO_SELLER);
        if (hasSoldAssets || hasCollapsedToInventoryAssets) {
          if (!this.canMoveSoldRBAsset && (hasRBSoldAssets || hasCollapsedToInventoryAssets)) {
            errorMessage = assetMessage.assetSoldStatusMoveError;
          } else if (!this.canMoveSoldIPAsset && hasIPSoldAssets) {
            errorMessage = assetMessage.assetPreviewOrInAuctionOrSoldStatusMoveError;
          } else if (this.isEventEndedMoreThan30DaysAgo && hasIPSoldAssets) {
            errorMessage = assetMessage.assetSoldStatusEventEndedMoreThan30DaysError;
          } else if (this.isEventEndedMoreThan120DaysAgo && (hasRBSoldAssets || hasCollapsedToInventoryAssets)) {
            errorMessage = assetMessage.assetSoldStatusEventEndedMoreThan120DaysError;
          } else if (hasCollapsedToInventoryAssets){
            if (this.assets.length > 1) {
              let counter = 0;
              this.assets.forEach(asset => {
                if (asset.assetStatusId === ASSET_STATUS_COLLAPSED_TO_INVENTORY) {
                  counter += 1;
                }
              });
              if (counter === this.assets.length) {
                warningMessage = assetMessage.movedCollapsedToInventoryAssetsError;
              } else {
                warningMessage = assetMessage.movedMultipleCollapsedAssets;
              }
            } else {
              warningMessage = assetMessage.movedCollapsedToInventoryAssetsError;
            }
          }
        } else if (hasCollapsedToSellerAssets) {
          if (this.assets.length > 1) {
            let counter = 0;
            this.assets.forEach(asset => {
              if (asset.assetStatusId === ASSET_STATUS_COLLAPSED_TO_SELLER){
                counter += 1;
              }
            });
            if(counter === this.assets.length && (this.isAtRiskContract() || this.isAtStraightContract())){
              warningMessage = assetMessage.movedCollapsedToSellerAssetsOnRiskContract;
            }else if (counter === this.assets.length && this.isExhibitAOrInventoryContract()){
              warningMessage = assetMessage.movedCollapsedToSellerAssetsOnInventoryContract;
            }else {
              warningMessage = assetMessage.movedMultipleCollapsedAssets;
            }
          } else if (this.isAtRiskContract() || this.isAtStraightContract()) {
            warningMessage = assetMessage.movedCollapsedToSellerAssetsOnRiskContract;
          } else if (this.isExhibitAOrInventoryContract()) {
            warningMessage = assetMessage.movedCollapsedToSellerAssetsOnInventoryContract;
          }
        }
      }

    } else if (this.auditAssetMove.destinationType === RETURN_TO_PREVIOUS_SALE) {
      this.assets.forEach( asset => {
        asset.auctionEventId = asset.pulledFromAuctionEventId;
        asset.saleType = asset.previousAuctionSaleType;
      });
    }

    if (errorMessage) {
      this.auditAssetMove.destinationType = null;
      this.dialogService.showMessageDialog(errorMessage);
    } else if (warningMessage) {
      this.dialogService.showMessageDialog(warningMessage);
    }
  }

  private isHoldingPenInfoValid(): boolean {
    return this.icForm && this.icForm.valid && this.isOwnerCodeAvailable && this.isScheduleAAvailable;
  }

  private validateOperationalEntity(opportunityId: number): void {
    this.dialogService.showProgress();
    this.operationalEntitySubscription = this.assetsService.checkOperationalEntity(opportunityId, this.assets).subscribe(
      (response) => {
        if (response && response.error) {
          let errorMessage;
          if (response.message && response.message.indexOf(assetMoveErrorCodes.invalidOperationalEntity) >= 0) {
            errorMessage = assetMessage.assetMoveOperationalEntityError;
          } else {
            errorMessage = assetMessage.assetMoveError;
            errorMessage.message = errorMessage.message.replace(':message', response.message);
          }
          this.dialogService.showMessageDialog(errorMessage);
        } else {
          this.assets = response;
          if(this.typeOfRiskError)
            this.validateRiskContracts();
          else {
            this.stepper.next();
          }
        }
        this.dialogService.hideProgress();
      }, error => {
        this.dialogService.showMessage('Unexpected error occurred while validating Operational Entity. Please contact tech support. ');
        this.dialogService.hideProgress();
      });
  }

  private subscribeAssetPackage(): void {
    this.dialogService.showProgress();
    const assetControlGroupId = this.assets[0].assetControlGroupId;
    this.assetPackageSubscription = this.assetControlGroupService.getAssetPackageInfo(assetControlGroupId).subscribe( assetControlGroup => {
      this.auditAssetMove.currentAssetControlGroup = assetControlGroup;
      this.getOpportunityDetails(assetControlGroup.opportunityId);
    });
  }

  private shouldValidateOperationalEntity(): boolean {
    if ( this.auditAssetMove.destinationType === MOVE_ASSET_INTO_OTHER_CONTRACT ) {
      const assetsEligibleforEntityCheck = this.assets.filter(asset => asset.assetStatusId === ASSET_STATUS_SOLD || asset.assetStatusId === ASSET_STATUS_COLLAPSED_TO_SELLER ||
        asset.assetStatusId === ASSET_STATUS_COLLAPSED_TO_INVENTORY);
      return assetsEligibleforEntityCheck != null && assetsEligibleforEntityCheck.length > 0;
    } else {
      return false;
    }
  }

  private isDifferentSourceTargetEventContract() : boolean {
    return this.assets.some(asset => asset.auctionEventId != this.selectedContract.primaryAuctionEventId);
  }

}
